export enum InvoiceSorting {
	CreatedAtAscending = 0,
	CreatedAtDescending = 1,
	DueDateAscending = 2,
	DueDateDescending = 3,
	InvoiceTotalAscending = 4,
	InvoiceTotalDescending = 5,
	StateAscending = 6,
	StateDescending = 7,
	AddressAscending = 8,
	AddressDescending = 9,
}
